/* eslint-disable */
import {
  Component,
  OnInit,
  Inject,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ViewChild,
  TemplateRef,
  OnDestroy,
  ViewContainerRef,
  ComponentFactoryResolver,
  Renderer2,
} from "@angular/core";
import { MexGridPageDataService } from "../mex-grid-page-data.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { environment } from "../../../environments/environment";
import copy from "copy-to-clipboard";
import { SetRightPanelCollapsed } from "src/app/store/actions/right-panel-actions";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription, forkJoin } from "rxjs";
import { AppService } from "src/app/app.service";
import { LineItemMonitorDataService } from "../../line-item-monitor/line-item-monitor-data.service";
import { UpdateLineItemParams } from "src/app/line-item-monitor/line-item-monitor.model";
import { GetUsliIdsResponse } from "../mex-grid-page.model";
import {
  VAIconRegistryService,
  copy as copyIcon,
} from "@va/core-library/icons";
import { PharmaDataService } from "src/app/pharma-page/pharma-data.service";
import { phaseAbbreviations } from "src/app/pharma-page/pharma-page.model";
import { NzCascaderComponent } from "ng-zorro-antd/cascader";
import { CompanyDataService } from "src/app/company-page/company-data.service";

declare var $: any;
declare function WebServiceCall(): void;
declare function qtipSettings(ele, qttype, panel): any;
declare function getYear(string): any;
declare function saveExtraPanelSetting(): any;
declare function cleanUpInspector(): any;
declare function clearInspectorDictionary(): any;
declare function debouncedBlock(loaderState): any;

@Component({
  selector: "app-mex-grid-table",
  templateUrl: "./mex-grid-table.component.html",
  styleUrls: ["./mex-grid-table.component.scss"],
  host: { class: "mex-grid-table-component" },
  encapsulation: ViewEncapsulation.None,
})
export class MexGridTableComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() onCurrencySet = new EventEmitter();
  @ViewChild("snackbarTemplateAddToMonitor")
  snackbarTemplateAddToMonitor: TemplateRef<any>;
  @ViewChild("biopharmaContextMenu", { static: true, read: ViewContainerRef })
  biopharmaContextMenu: ViewContainerRef;
  hasPharmaAccess = true;
  phaseAbbr = phaseAbbreviations;
  assetUrl = environment.assetUrl;
  fiscalEnd = "";
  // //hiding the chart directive on initial load
  isVisible = false;
  showDistribution = true;
  showSurprise = true;
  firstTimeCall = true;
  firstBindChart = true;
  customOrCPlusSource = false;
  showRevision: boolean;
  isDefaultCurrencySet: boolean = false;
  filingsPerPeriodDict = {};
  allowVAExcelCopyOption: boolean = true;
  showLeftPanel = true;
  rightPanelData: any = {};
  view: string = "";
  analyticsLogLevel: string = "";
  sellSideBrokerShortname: string = "";
  selectedCurrency: string;
  showQcDashboard: any;
  lineItemData: any;
  periodData: any;
  allDimData: any;
  tabs: any;
  sourceData: any;
  webServiceCallInterval: any;
  metaCalls: number;
  industryId: number;
  isLineItemContextMenu: boolean = false;
  showPeerRev: boolean;
  isCompareToPeer: boolean;
  cut: string = "";
  contextMenuDiv: any;
  chartType: string;
  chartReady: boolean = false;
  dataUsed: any;
  pharmaParms: {
    companyids: number[];
    columns: string[];
    period_basis: string;
    period_type: string;
    revenue_type: string;
  } = {
    companyids: [],
    columns: ["api", "moa", "target", "indications"],
    period_basis: "calendar",
    period_type: "",
    revenue_type: "total_revenue",
  };
  // mexLoaded = false;
  beginningStateReferrer: string = "";
  feature: string = "";
  panelData = [];
  pageParamsSubcription: Subscription;
  pharmaMetaSubscription: Subscription;
  nmvSliMapReady = false;
  invisibleMenu = false;
  contextMenuSource: string = "";
  ticker: string = "";
  showAsPctOfOption: string = "";
  cutMap = {
    NMV: "CD",
    STD: "SD",
    SAR: "AD",
    SCH: "CD",
  };
  responseMessage: string = "";
  messageSuffix: string = "";
  currentDapObj: any = {};
  showResearchPopup: boolean = false;
  allPgData = [];
  allPgDataFetched: boolean = false;
  firstTimePgCall: boolean = true;
  showLoader: boolean = true;
  showLoaderClearAll: boolean = false;
  loadgridListener: EventListener;
  activatePeersListener: EventListener;
  biopharma_mex_grid_meta: { [key: string]: any } = {};
  constructor(
    private dataService: MexGridPageDataService,
    private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private appService: AppService,
    private limDataService: LineItemMonitorDataService,
    private companyDataService: CompanyDataService,
    private iconRegistry: VAIconRegistryService,
    private pharmaService: PharmaDataService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private renderer: Renderer2,
  ) {
    this.iconRegistry.registerIcons([copyIcon]);
  }

  ngOnInit() {
    this.pageParamsSubcription = this.store
      .select(stateGetter("navigationSettings", "pageParams"))
      .subscribe((pageParams) => {
        if (pageParams.pageName === "mex") {
          //debouncedBlock(true);
          window.company = pageParams.ticker;
          this.ticker = window.company;
          window.cut = pageParams.cut;
          this.cut = window.cut;
          window.pg = decodeURIComponent(pageParams.pg);
          window.gSource = pageParams.source || "";
          window.source = window.gSource;
          let queryParams = this.route.snapshot.queryParams;
          window.highlightDp = queryParams["dpid"] || "";
          window.gBasis = queryParams["basis"] || "All";
          window.gAdjust = queryParams["depth"] || "";
          window.gVariant = queryParams["variant"] || "";
          window.gRevision = queryParams["revision"] || "";
          window.gScenario = queryParams["scenario"] || "";
          window.editScenario = queryParams["edit_scenario"] || "";
          window.compositeEdit = queryParams["edit"] || "";
          window.highlightPeriod = queryParams["period"] || "";
          window.loadRevision = queryParams["load_revision"] || "";
          window.periodRevision = queryParams["period_revision"] || "";
          window.expandConsensus =
            queryParams["expand_consensus"] &&
            queryParams["expand_consensus"] == "true"
              ? true
              : false;

          window.userSettingTicker = "";
          window.fiscalEnd = "";
          this.showRevision = window.cut === "SCH" ? false : true;
          window.filingsPerPeriodDict = {};
          window.panelSections = {
            periods: {
              secType: "periods",
              secName: "periods",
              clearId: "clear_periods",
              displayName: "Periods",
              className: "fa-calendar",
            },
            Periods: {
              secType: "periods",
              secName: "periods",
              clearId: "clear_periods",
              displayName: "Periods",
              className: "fa-calendar",
            },
            Sources: {
              secType: "sources",
              secName: "Sources",
              clearId: "clear_sources",
              displayName: "Sources",
              className: "fa-th",
            },
            "Company Comps": {
              secType: "companycomps",
              secName: "Company Comps",
              clearId: "clear_companycomps",
              displayName: "Company Comps",
              className: "",
            },
            Revisions: {
              secType: "historicalestimates",
              secName: "Revisions",
              clearId: "clear_historicalestimates",
              displayName: "Historical Estimates",
              className: "fa-history",
            },
            "Accounting basis": {
              secType: "accountingbasis",
              secName: "Accounting basis",
              clearId: "clear_accountingbasis",
              displayName: "Accounting Basis",
              className: "fa-calculator",
            },
            Adjustments: {
              secType: "inferreddata",
              secName: "Adjustments",
              clearId: "clear_inferreddata",
              displayName: "Inferred Data",
              className: "fa-file-text-o",
            },
            GrowthTypes: {
              secType: "analytics(labs)",
              secName: "GrowthTypes",
              clearId: "clear_analyticslabs",
              displayName: "Analytics (Labs)",
              className: "fa-line-chart",
            },
            Analysis: {
              secType: "visualizations(labs)",
              secName: "Analysis",
              clearId: "clear_visualizationslabs",
              displayName: "Visualizations (Labs)",
              className: "fa-table",
            },
          };
          this.view = window.cut;
          // not sure if we need this
          // window.analyticsLogLevel = response.ANALYTICS_LOG_LEVEL;
          // this.sellSideBrokerShortname = response.sell_side_broker_shortname; // not sure if we need this
          // this.showQcDashboard = response.show_qc_dashboard;
          // window.userSettingTicker = response.user_setting_ticker;
          // window.currencyCompatible = response.currency_compatible;

          $(window)
            .off("bindMexContextMenu")
            .on("bindMexContextMenu", (param, data) => {
              this.bindMexContextMenu(data.target, data.contextMenuDiv);
            });

          this.firstTimeCall = true;
          setTimeout(() => {
            this.loadGridCalled(this.firstTimeCall, "All");
            this.firstTimeCall = false;
            this.getGridMeta();
          });
        }
      });

    let companyMeta = this.companyDataService.getCompanyMeta(window.company);
    companyMeta.subscribe((resp) => {
      this.industryId = resp["industryid"];
    });
    this.loadgridListener = (params: any) => {
      if (params.detail.url) {
        this.loadGridCalled(
          params.detail.firstCall,
          params.detail.sectionName,
          params.detail.url,
        );
      } else {
        this.loadGridCalled(
          params.detail.firstCall,
          params.detail.sectionName,
          "",
          params.detail.clearAllPreset,
        );
      }
    };
    window.addEventListener("CallLoadGrid", this.loadgridListener);
    window.addEventListener("GetAllPgData", (params: any) =>
      this.getAllPgData(params.detail.onlyPgCall),
    );
    window.addEventListener("ShowHideLoader", (params: any) =>
      this.showHideLoader(params.detail.showLoader),
    );

    window.addEventListener("showChart", (params: any) => {
      this.dataUsed = params.detail.dataToUse;
      this.chartType = params.detail.type;
      this.chartReady = true;
    });
    window.addEventListener("routeChangedFromLib", (params: any) => {
      this.router.navigateByUrl(params.detail.url);
    });

    window.addEventListener("copyValueToClipboard", (params: any) => {
      copy(params.detail.text, { format: "text/plain" });
      this.snackBar.open(`${params.detail.text} copied to clipboard`, "", {
        panelClass: "info",
        duration: 3000,
        verticalPosition: "top",
      });
    });
    window.addEventListener("nmvSliMapState", (params: any) => {
      this.nmvSliMapReady = params.detail.state;
      this.showPeerRev =
        this.contextMenuDiv &&
        window["selectedLineStdAndCompDict"][
          window.pg + this.contextMenuDiv.attr("dapparam_id")
        ] &&
        (window["selectedLineStdAndCompDict"][
          window.pg + this.contextMenuDiv.attr("dapparam_id")
        ]["stdMappings"].length === 0 ||
          !window["selectedLineStdAndCompDict"][
            window.pg + this.contextMenuDiv.attr("dapparam_id")
          ]["hasPeers"])
          ? false
          : true;
      if (this.nmvSliMapReady && !this.isLineItemContextMenu) {
        this.invisibleMenu = true;
        setTimeout(() => {
          const recomputeContextPosition = new CustomEvent(
            "recomputeContextPosition",
            { detail: {} },
          );
          window.dispatchEvent(recomputeContextPosition);
          this.invisibleMenu = false;
        }, 100);
      }
    });
    window.addEventListener("displayMetaError", (dataObj: any) => {
      this.dataService.displayMetaError(dataObj.detail.data);
    });
    //add event listener for showResearchInsightPopup popup
    window.addEventListener("showResearchInsightPopup", (dataObj: any) => {
      this.showResearchInsightPopup(dataObj.detail);
    });
    this.activatePeersListener = () => {
      let lineItemSet = window.MEData.row_dimensions.filter((item) => {
        return item.name.toLowerCase() === "lineitems";
      })[0];
      let dapIds = lineItemSet.values.map((dap) => dap.id);
      this.dataService
        .loadUsliIds(dapIds, this.ticker)
        .subscribe((response: GetUsliIdsResponse) => {
          window.usliIds = response.data;
          let selectedData = $("#tt").datagrid("getSelected");
          if (selectedData == null) {
            let dgRows = $("#tt").datagrid("getRows");
            selectedData = dgRows[0];
          }
          let selectedDataId = selectedData.id.split("-")[0];
          let iconSelector = `.compareToPeerIcon-${selectedDataId}`;
          if (window.cut === "NMV") {
            Object.keys(response.data).forEach((lineId) => {
              let usliIds = response.data[lineId];
              if (usliIds.length) {
                let iconId = `.compareToPeerIcon-${lineId}`;
                $(iconId).show();
              }
            });
          }
          if (Object.keys(response.data).length) {
            // find selected row and activate peers tab in inspector if selected row's peer icon is enabled
            if ($(iconSelector).is(":visible")) {
              $("#footerTypeDiv #TdPeers").css("display", "inherit");
              $("#footerTypeDiv #TdPeers").css("visibility", "visible");
            }
          }
          // set stdMappings to window object, so that when right click is done on a row
          // it can also use same usliIds for showing peer chart options
          if (window.cut === "NMV") {
            dapIds.forEach((dapId) => {
              let stdMappingValues = window.usliIds[dapId];

              let stdMappings = [];
              if (stdMappingValues) {
                stdMappingValues.forEach((std) => {
                  stdMappings.push([std, response.usli_name_map[std]]);
                });
              }
              window.selectedLineStdAndCompDict[window.pg + dapId] = {
                stdMappings: stdMappings,
                hasPeers: stdMappings.length ? true : false,
              };
            });
            let sliMappingData =
              window.selectedLineStdAndCompDict[window.pg + selectedDataId];
            window.fetchComptableMappings(
              sliMappingData.stdMappings,
              selectedDataId,
            );
          }
        });
    };
    window.addEventListener("activatePeers", this.activatePeersListener);
    window.addEventListener("applyPharmaSettings", this.handlePharmaSettings);
  }
  handlePharmaSettings = () => {
    this.getPharmaMetaData();
  };

  ngOnDestroy() {
    if (this.pageParamsSubcription) {
      this.pageParamsSubcription.unsubscribe();
    }

    if (this.pharmaMetaSubscription) {
      this.pharmaMetaSubscription.unsubscribe();
    }
    window.removeEventListener(
      "applyPharmaSettings",
      this.handlePharmaSettings,
    );

    window.removeEventListener("activatePeers", this.activatePeersListener);
    if (this.loadgridListener) {
      window.removeEventListener("CallLoadGrid", this.loadgridListener);
      this.loadgridListener = null;
    }
  }

  debounce(callback, wait) {
    let timeout;
    return (...args) => {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => callback.apply(context, args), wait);
    };
  }

  bindMexContextMenu(target, contextMenuDiv) {
    this.contextMenuDiv = contextMenuDiv;
    if (this.firstBindChart) {
      $(".context-menu-options.charts").on("click", this.openChart.bind(this)); // TODO
      this.firstBindChart = false;
    }
    var source = target.attr("source").toLowerCase();
    this.contextMenuSource = source;
    var checkSource = source.match(/(consensus)/gi);

    if (source == "filings") {
      this.showSurprise = true;
      this.showDistribution = false;
      this.showRevision = false;
      setTimeout(() => {
        // TODO
        $(".context-menu-surprise")
          .off("click", this.openChart.bind(this))
          .on("click", this.openChart.bind(this));
        $(".context-menu-revision")
          .off("click", this.openChart.bind(this))
          .on("click", this.openChart.bind(this));
      }, 300);
    } else if (source == "va actuals") {
      this.showSurprise = true;
      this.showDistribution = false;
      this.showRevision = true;
      setTimeout(() => {
        // TODO
        $(".context-menu-surprise")
          .off("click", this.openChart.bind(this))
          .on("click", this.openChart.bind(this));
        $(".context-menu-revision")
          .off("click", this.openChart.bind(this))
          .on("click", this.openChart.bind(this));
      }, 300);
    } else {
      this.showRevision = true;
      this.showSurprise = true;
      setTimeout(() => {
        // TODO
        $(".context-menu-surprise")
          .off("click", this.openChart.bind(this))
          .on("click", this.openChart.bind(this));
        $(".context-menu-revision")
          .off("click", this.openChart.bind(this))
          .on("click", this.openChart.bind(this));
      }, 300);
    }
    if (checkSource && checkSource.length > 0) {
      this.showDistribution = true;
      setTimeout(() => {
        // TODO
        $(".context-menu-distribution")
          .off("click", this.openChart.bind(this).bind(this))
          .on("click", this.openChart.bind(this).bind(this));
      }, 300);
    } else {
      this.showDistribution = false;
    }
    // //TODO change this condition to manage surprise chart context menu

    if (
      target.attr("forecast") === "true" ||
      window.MEData.view_code == "SAR"
    ) {
      this.showSurprise = false;
    } else if (!this.showSurprise && window.MEData.view_code != "SAR") {
      this.showSurprise = true;
      setTimeout(() => {
        // TODO
        $(".context-menu-surprise")
          .off("click", this.openChart.bind(this).bind(this))
          .on("click", this.openChart.bind(this))
          .bind(this);
      }, 100);
    }

    this.showPeerRev =
      window["selectedLineStdAndCompDict"][
        window.pg + target.attr("dapparam_id")
      ] &&
      (window["selectedLineStdAndCompDict"][
        window.pg + target.attr("dapparam_id")
      ]["stdMappings"].length === 0 ||
        !window["selectedLineStdAndCompDict"][
          window.pg + target.attr("dapparam_id")
        ]["hasPeers"])
        ? false
        : true;

    this.isLineItemContextMenu = false;
    if (target.attr("isLineItemContextMenu") == "true") {
      this.isLineItemContextMenu = true;
      this.nmvSliMapReady = true;
      setTimeout(() => {
        // TODO
        // add line item to monitor trigger
        // $('.context-menu-addToMonitor').off('click', this.addToMonitor).on('click', this.addToMonitor);
      }, 100);
    }

    setTimeout(function () {
      // $('.context-menu-copyLineItemName').off('click', this.copyLineItemName).on('click', this.copyLineItemName);
      // $('.context-menu-copyLineItemCode').off('click', copyLineItemCode).on('click', copyLineItemCode);
      // $('.context-menu-audit').off('click', auditClicked).on('click', auditClicked)
      // $('.context-menu-vaexcel').off('click', copyExcelAddin).on('click', copyExcelAddin);
    }, 100);

    this.isCompareToPeer = false;
    if (
      target.attr("isCompareToPeer") == "true" &&
      target.attr("source").toLowerCase() !== "filings"
    ) {
      // Compare to peer trigger
      this.isCompareToPeer = true;
    }

    if (
      this.contextMenuSource === "consensus" &&
      this.cut === "NMV" &&
      this.showPeerRev
    ) {
      setTimeout(() => {
        // $(".context-menu-compareToPeer")
        //   .off("click", InspectorClick.bind(true, "peers", "peers"))
        //   .on("click", InspectorClick.bind(true, "peers", "peers"));
        $(".context-menu-peer-rev")
          .off("click", this.openChart.bind(this))
          .on("click", this.openChart.bind(this));
        $(".context-menu-peer-trend")
          .off("click", this.openChart.bind(this))
          .on("click", this.openChart.bind(this));
      }, 100);
    }

    var contextForWhichRow = target.closest("tr").attr("datagrid-row-index");
    var isLinkToNMVVisible = $("#wrap .datagrid-view1 .datagrid-body")
      .find('[datagrid-row-index="' + contextForWhichRow + '"]')
      .find(".link-img")
      .css("visibility");
    if (window.MEData.view_code === "SCH" && isLinkToNMVVisible === "visible") {
      this.allowVAExcelCopyOption = true;
    } else if (
      window.MEData.view_code === "SCH" &&
      isLinkToNMVVisible === "hidden"
    ) {
      this.allowVAExcelCopyOption = false;
    }
    this.customOrCPlusSource = false;
    if (
      window.MEData.view_code == "SCH" ||
      window.MEData.view_code == "NMV" ||
      window.MEData.view_code == "STD"
    ) {
      if (source == "custom" || source == "consensus+") {
        this.isLineItemContextMenu = false;
        this.customOrCPlusSource = true;
        this.showSurprise = false;
        this.showDistribution = false;
        this.showRevision = false;
        this.showPeerRev = false;
      }
    }
  }

  onAuditFormulaClick() {
    window.auditClicked();
  }
  navigateToDedicatedPage(value: string) {
    const dapparam_id = this.contextMenuDiv.attr("dapparam_id");
    const period = this.contextMenuDiv.attr("period");
    if (this.cut === "NMV") {
      window.open(
        `/charts/current?ticker=${
          window.MEData.ticker
        }&lineId=${dapparam_id}&chartTypeId=${
          value === "trend-peer" ? 2 : 3
        }&periods=${period}&cut=NMV`,
        "_blank",
      );
      return;
    }
    if (this.cut === "STD") {
      window.open(
        `/charts/current?ticker=${
          window.MEData.ticker
        }&lineId=${dapparam_id}&chartTypeId=${
          value === "trend-peer" ? 2 : 3
        }&periods=${period}`,
        "_blank",
      );
      return;
    }
  }

  openChart(event) {
    var $target = $(event.currentTarget),
      value = $target.attr("value"),
      dapparam_id = this.contextMenuDiv.attr("dapparam_id"),
      source = this.contextMenuDiv.attr("source"),
      period = this.contextMenuDiv.attr("period"),
      forecast = this.contextMenuDiv.attr("forecast"),
      iscomparetopeer = this.contextMenuDiv.attr("iscomparetopeer");
    var periodsPanel = window.MEData.panels.filter(function (value) {
      return value.name == "periods";
    })[0];

    if (value === "revision-peer" || value === "trend-peer") {
      return;
    }

    let currentQuarter = periodsPanel.currentquarter;

    const a = window.MEData.panels.filter(function (item) {
      return item.name.toLowerCase() === "sources";
    })[0];
    const defaultData = a.values.filter(function (again) {
      return again.name.toLowerCase() === "brokers";
    })[0];
    const sourcesList = defaultData.values.map(function (n) {
      return {
        label: n.name,
        value: n.name,
        checked: source === n.name,
        excluded: n.excluded,
      };
    });

    //Injecting controller specific scope to access the directive
    this.chartType = value;
    var dataToUse = {};
    dataToUse["extraData"] = {};
    dataToUse["ticker"] = window.MEData.ticker;
    dataToUse["dapparamId"] = dapparam_id;
    dataToUse["period"] = period;
    dataToUse["currentQuarter"] = currentQuarter;
    dataToUse["companyFullName"] = window.MEData.company_name;
    dataToUse["gAdjust"] = window.gAdjust === "" ? "implied" : window.gAdjust;
    dataToUse["source"] = source;
    dataToUse["cut"] = window.MEData.view_code;
    dataToUse["forecast"] = forecast === "true" ? true : false;
    dataToUse["sourceList"] = sourcesList;
    dataToUse["isPeers"] = iscomparetopeer == "true";
    dataToUse["selectedCurrency"] = window.MEData.selectedCurrency;
    dataToUse["export"] = true;
    this.chartReady = true;
    this.dataUsed = dataToUse;
  }
  showHideLoader(showLoader) {
    if (this.showLoader && showLoader === false) {
      if (
        environment.datadogRum &&
        environment.datadogRum.active &&
        window.DD_RUM
      ) {
        const timing = Date.now();
        window.DD_RUM.addTiming("mex_page_grid_loaded", timing);
      }
    }
    this.showLoader = showLoader;
    this.showLoaderClearAll = window.MEData.user_dim_setting;
  }

  addToMonitor() {
    var dapparam_id = this.contextMenuDiv.attr("dapparam_id");
    // var period = window.MEData.panels.filter((val) => {
    //   return val.name.toLowerCase() == "periods";
    // })[0].first_estimated_fiscal;

    var headerLinksJson = {
      ticker: window.company,
      lineIds: [Number(dapparam_id)],
      fromMexPage: true,
    };
    this.addToMonitorUpdate(headerLinksJson);
  }

  onChangeAnalyticInclusion(analyticName: string, event: Event) {
    let id = this.contextMenuDiv.attr("id").split("-")[0];
    let growthTypesObject = window.MEData.panels.filter(function (panel) {
      return panel.name.toLowerCase() == "growthtypes";
    })[0];
    if (growthTypesObject) {
      if (
        growthTypesObject.expandedRows &&
        growthTypesObject.expandedRows.length > 0
      ) {
        growthTypesObject.expandedRows.push(id);
      } else {
        growthTypesObject.expandedRows = [id];
      }
    }
    const handleAnalystApply = new CustomEvent("handleAnalystApply", {
      detail: {
        analyticName: analyticName,
        event: event,
      },
    });
    window.dispatchEvent(handleAnalystApply);
  }

  copyExcelAddin() {
    if (this.allowVAExcelCopyOption === false) {
      return false;
    }
    var adjustmentData, impliedValue;
    var lineItemSet = window.MEData.row_dimensions.filter((item) => {
      return item.name.toLowerCase() === "lineitems";
    })[0];

    var requiredLineItemObj = lineItemSet.values.filter((item) => {
      return (
        (window.MEData.view_code !== "SAR" &&
        window.MEData.view_code !== "SCH" &&
        window.MEData.view_code !== "STD"
          ? item.dapparameterid
          : item.id) == parseInt(this.contextMenuDiv.attr("dapparam_id"))
      );
    })[0];

    var requiredLineItemName = requiredLineItemObj.name;
    if (window.MEData.view_code === "NMV") {
      adjustmentData = window.MEData.panels.filter((item) => {
        return item.name.toLowerCase() === "adjustments";
      })[0];
    }
    impliedValue = "";
    var excelAddInFormulaToCopy = "";
    var isRevisionOnRow = window.MEData.row_dimensions.filter((item) => {
      return item.name.toLowerCase() == "revisions";
    });
    var revFormula = "";
    if (isRevisionOnRow.length != 0) {
      //Added this to check if the datapoint clicked is an historical forecast or a current value
      var revVal = this.contextMenuDiv.attr("revision").toLowerCase();
      if (revVal === "current") {
        revFormula = ',""';
      } else if (revVal === "preq") {
        revFormula = ',"preq"';
      } else {
        revFormula =
          ',"' +
          this.appService.getFormattedDate(
            this.contextMenuDiv.attr("id").split("|")[1],
            "dd-mmm-yyyy",
          ) +
          '"';
      }
      excelAddInFormulaToCopy = this.excelAddInFormulaToCopy(
        requiredLineItemName,
        impliedValue,
        revFormula,
        requiredLineItemObj,
      );
    } else {
      //Added this to check if the datapoint clicked is an historical forecast or a current value
      var fieldToCheck = this.contextMenuDiv.attr("field");
      if (fieldToCheck.indexOf("current") !== -1) {
        revFormula = ',""';
      } else if (fieldToCheck.indexOf("preq") !== -1) {
        revFormula = ',"preq"';
      } else {
        //Adding this for the case when there is no revision applied at all
        var isRevisionOnCol = window.MEData.column_dimensions.filter((item) => {
          return item.name.toLowerCase() == "revisions";
        });
        if (isRevisionOnCol.length !== 0) {
          revFormula =
            ',"' +
            this.appService.getFormattedDate(
              this.contextMenuDiv.attr("id").split("|")[1],
              "dd-mmm-yyyy",
            ) +
            '"';
        } else {
          revFormula = ',""';
        }
      }
      excelAddInFormulaToCopy = this.excelAddInFormulaToCopy(
        requiredLineItemName,
        impliedValue,
        revFormula,
        requiredLineItemObj,
      );
    }

    copy(excelAddInFormulaToCopy, { format: "text/plain" });

    this.snackBar.open(`${excelAddInFormulaToCopy} copied to clipboard`, "", {
      panelClass: "info",
      duration: 3000,
      verticalPosition: "top",
    });
  }

  excelAddInFormulaToCopy(
    requiredLineItemName: string,
    impliedValue: any,
    revFormula: string,
    requiredLineItemObj: any,
  ): string {
    let excelAddInFormulaToCopy =
      '=VAData("' +
      /* ticker ==> */ window.userSettingTicker +
      /* period ==> */ '", "' +
      this.contextMenuDiv.attr("period") +
      /* parameter ==> */ '", "' +
      (window.MEData.view_code !== "SAR"
        ? requiredLineItemName
        : this.contextMenuDiv.attr("dapparam_id")) +
      /* source ==> */ '", "' +
      (window.MEData.view_code === "SAR"
        ? window.MEData.source
        : this.contextMenuDiv.attr("source")) +
      /* view ==> */ '", "' +
      this.cutMap[window.MEData.view_code] +
      /* depth ==> */ '", "' +
      impliedValue +
      '"' +
      /* revision ==> */ revFormula +
      /* growthtype ==> */ ',""' + // setting growthType blank
      /* If Currency ==> */ (window.MEData.selectedCurrency != "Base" &&
      (window.MEData.view_code === "STD" ||
        window.MEData.view_code === "NMV") &&
      window.currencyCompatible == "true"
        ? ',"' +
          /* magnitude ==> */ requiredLineItemObj.magnitude +
          '"' +
          ',"' +
          /* currency ==> */ window.MEData.selectedCurrency +
          '"'
        : "") +
      ")";
    return excelAddInFormulaToCopy;
  }

  copyLineItemName() {
    var lineItemName = this.contextMenuDiv.attr("lineItemName");
    copy(lineItemName);
    this.snackBar.open(`${lineItemName} copied to clipboard`, "", {
      panelClass: "info",
      duration: 3000,
      verticalPosition: "top",
    });
  }
  copyLineItemCode() {
    var lineItemCode = this.contextMenuDiv.attr("lineItemCode");
    copy(lineItemCode);
    this.snackBar.open(`${lineItemCode} copied to clipboard`, "", {
      panelClass: "info",
      duration: 3000,
      verticalPosition: "top",
    });
  }

  getGridMeta() {
    this.dataService
      .getGridMeta(window.pg, window.cut, window.company, window.source)
      .subscribe(
        (response) => {
          window.analyticsLogLevel = response.ANALYTICS_LOG_LEVEL; // not sure if we need this
          this.sellSideBrokerShortname = response.sell_side_broker_shortname; // not sure if we need this
          window.userSettingTicker = response.user_setting_ticker;
          // window.currencyCompatible = response.currency_compatible;
        },
        (error) => {
          console.error(error);
        },
      );
  }
  getSarToNmvLinks() {
    this.dataService
      .getSarToNmvLinksData(
        window.company,
        window.cut,
        window.pg,
        window.source,
      )
      .subscribe(
        (response) => {
          window.sarToNmvLinks = response.nmv_links;
        },
        (error) => {
          console.error(error);
        },
      );
  }

  loadGridCalled(
    firstTimeCall: boolean,
    sectionName: string,
    extraParams?: any,
    clearAllPreset?: false,
  ) {
    /*
    To clean @param expandedRowList when cut changes.
    after angular implementation mainGrid3.js is not reloaded for view changes.
    hence maintains previous entries of @param expandedRowList
    ref bug: CACHE-2104
    */
    debouncedBlock(true);
    window.expandedRowList = [];

    //clear data cached for inspector
    clearInspectorDictionary();
    if (this.cut !== "SAR" && this.cut !== "SCH") {
      this.firstTimePgCall = true;
      this.allPgData = [];
      this.getAllPgData();
    }
    if (firstTimeCall) {
      let params = `?ticker=${window.company}&pg=${encodeURIComponent(
        window.pg,
      )}&cut=${window.cut}`;
      params = window.source
        ? `${params}&source=${
            window.source.toLowerCase() === "consensusplus"
              ? encodeURIComponent("Consensus+")
              : encodeURIComponent(window.source)
          }`
        : params;
      params = window.expandConsensus
        ? `${params}&expand_consensus=${window.expandConsensus}`
        : params;
      params = window.highlightPeriod
        ? `${params}&period=${window.highlightPeriod}`
        : params;
      params = window.highlightDp
        ? `${params}&dpid=${window.highlightDp}`
        : params;
      if (extraParams) {
        params += extraParams;
      }
      this.metaCalls = 3;
      // lineitems meta start
      if (clearAllPreset === undefined) {
        this.metaCalls = 4;
        this.dataService.getLineItemMeta(params).subscribe(
          (respObject) => {
            const errMsg = {
              message:
                'This feature is part of Insights Pro, if you would like to upgrade your subscription please reach out to <a href="mailto:support@visiblealpha.com">support@visiblealpha.com</a>',
            };

            if (respObject.status == "error") {
              this.dataService.displayMetaError(errMsg); // maingrid3.js fn
              return;
            }
            this.lineItemData = respObject;
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
          (error) => {
            this.metaCalls--;
            console.error(error);
          },
        );

        // Other Dim Meta start
        this.dataService.getOtherDimensionsMeta(params).subscribe(
          (respObject) => {
            if (respObject.status == "error") {
              this.dataService.displayMetaError(respObject); // maingrid3.js fn
              return;
            }
            this.allDimData = respObject;
            this.metaCalls--;
            this.store.dispatch(
              new SetRightPanelCollapsed(
                !this.allDimData.panel_state.rightPanel,
              ),
            );
            // this.populateHistoricalEstimates(respObject);
            // this.populateVisualizations(respObject);
            this.checkIfMetaDone(sectionName);
          },
          (error) => {
            console.error(error);
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
        );
        // Other Dim Meta end
        // Source meta start
        this.dataService.getSourceMeta(params).subscribe(
          (respObject) => {
            if (respObject.status == "error") {
              this.dataService.displayMetaError(respObject); // maingrid3.js fn
              return;
            }
            this.sourceData = respObject;
            this.metaCalls--;
            // this.store.dispatch(
            //   new GetSourceMeta({
            //     ticker: window.company,
            //     isClear: respObject.panels[0].clear_dimension,
            //     loaded: true,
            //     data: respObject.panels[0]
            //   })
            // );
            this.checkIfMetaDone(sectionName);
          },
          (error) => {
            console.error(error);
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
        );
        // Source meta end
        // Period meta start
        this.dataService.getPeriodsMeta(params).subscribe(
          (respObject) => {
            if (respObject.status == "error") {
              this.dataService.displayMetaError(respObject); // maingrid3.js fn
              return;
            }
            this.periodData = respObject;

            window.filingsPerPeriodDict =
              this.periodData.panels[0].filing_date_data;
            // const periods = respObject.panels[0];
            // const payload: Periods = {
            //   clearDimension: periods.clear_dimension,
            //   firstEstimatedYear: periods.first_estimated_year,
            //   from: periods.from,
            //   to: periods.to,
            //   interimType: periods.interim_type,
            //   multiPeriod: periods.multi_period,
            //   periodType: periods.period_type,
            //   selectedFrom: periods.selected_from.slice(3, 7),
            //   selectedTo: periods.selected_to.slice(3, 7)
            // };

            // this.store.dispatch(new SetPeriods(payload));
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
          (error) => {
            console.error(error);
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
        );
      } else if (!clearAllPreset) {
        params = `?ticker=${window.company}&pg=${window.pg}&cut=${window.cut}`;
        params = window.source
          ? `${params}&source=${
              window.source.toLowerCase() === "consensusplus"
                ? encodeURIComponent("Consensus+")
                : encodeURIComponent(window.source)
            }`
          : params;
        params = window.expandConsensus
          ? `${params}&expand_consensus=${window.expandConsensus}`
          : params;
        this.metaCalls = 1;
        if (
          sectionName.toLowerCase() === "growthtypes" ||
          sectionName.toLowerCase() === "revisions" ||
          sectionName.toLowerCase() === "analysis" ||
          sectionName.toLowerCase() === "adjustments" ||
          sectionName.toLocaleLowerCase() === "accounting basis"
        ) {
          // Other Dim Meta start
          this.dataService.getOtherDimensionsMeta(params).subscribe(
            (respObject) => {
              if (respObject.status == "error") {
                this.dataService.displayMetaError(respObject); // maingrid3.js fn
                return;
              }
              this.allDimData = respObject;
              this.metaCalls--;
              this.store.dispatch(
                new SetRightPanelCollapsed(
                  !this.allDimData.panel_state.rightPanel,
                ),
              );
              // this.populateHistoricalEstimates(respObject);
              // this.populateVisualizations(respObject);
              this.checkIfMetaDone(sectionName);
            },
            (error) => {
              console.error(error);
              this.metaCalls--;
              this.checkIfMetaDone(sectionName);
            },
          );
          // Other Dim Meta end
        } else if (sectionName.toLowerCase() === "sources") {
          // Source meta start
          this.dataService.getSourceMeta(params).subscribe(
            (respObject) => {
              if (respObject.status == "error") {
                this.dataService.displayMetaError(respObject); // maingrid3.js fn
                return;
              }
              this.sourceData = respObject;
              this.metaCalls--;
              // this.store.dispatch(
              //   new GetSourceMeta({
              //     ticker: window.company,
              //     isClear: respObject.panels[0].clear_dimension,
              //     loaded: true,
              //     data: respObject.panels[0]
              //   })
              // );
              this.checkIfMetaDone(sectionName);
            },
            (error) => {
              console.error(error);
              this.metaCalls--;
              this.checkIfMetaDone(sectionName);
            },
          );
          // Source meta end
        } else if (sectionName.toLowerCase() === "periods") {
          // Period meta start
          this.dataService.getPeriodsMeta(params).subscribe(
            (respObject) => {
              if (respObject.status == "error") {
                this.dataService.displayMetaError(respObject); // maingrid3.js fn
                return;
              }
              this.periodData = respObject;

              window.filingsPerPeriodDict =
                this.periodData.panels[0].filing_date_data;
              // const periods = respObject.panels[0];
              // const payload: Periods = {
              //   clearDimension: periods.clear_dimension,
              //   firstEstimatedYear: periods.first_estimated_year,
              //   from: periods.from,
              //   to: periods.to,
              //   interimType: periods.interim_type,
              //   multiPeriod: periods.multi_period,
              //   periodType: periods.period_type,
              //   selectedFrom: periods.selected_from.slice(3, 7),
              //   selectedTo: periods.selected_to.slice(3, 7)
              // };

              // this.store.dispatch(new SetPeriods(payload));
              this.metaCalls--;
              this.checkIfMetaDone(sectionName);
            },
            (error) => {
              console.error(error);
              this.metaCalls--;
              this.checkIfMetaDone(sectionName);
            },
          );
          // Period meta end
        }
      } else {
        this.metaCalls = 4;

        //Line Item Meta
        this.dataService.getLineItemMeta(params).subscribe(
          (respObject) => {
            const errMsg = {
              message:
                'This feature is part of Insights Pro, if you would like to upgrade your subscription please reach out to <a href="mailto:support@visiblealpha.com">support@visiblealpha.com</a>',
            };

            if (respObject.status == "error") {
              this.dataService.displayMetaError(errMsg); // maingrid3.js fn
              return;
            }
            this.lineItemData = respObject;
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
          (error) => {
            this.metaCalls--;
            console.error(error);
          },
        );
        // Other Dim Meta start
        this.dataService.getOtherDimensionsMeta(params).subscribe(
          (respObject) => {
            if (respObject.status == "error") {
              this.dataService.displayMetaError(respObject); // maingrid3.js fn
              return;
            }
            this.allDimData = respObject;
            this.metaCalls--;
            this.store.dispatch(
              new SetRightPanelCollapsed(
                !this.allDimData.panel_state.rightPanel,
              ),
            );
            // this.populateHistoricalEstimates(respObject);
            // this.populateVisualizations(respObject);
            this.checkIfMetaDone(sectionName);
          },
          (error) => {
            console.error(error);
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
        );
        // Other Dim Meta end
        // Source meta start
        this.dataService.getSourceMeta(params).subscribe(
          (respObject) => {
            if (respObject.status == "error") {
              this.dataService.displayMetaError(respObject); // maingrid3.js fn
              return;
            }
            this.sourceData = respObject;
            this.metaCalls--;
            // this.store.dispatch(
            //   new GetSourceMeta({
            //     ticker: window.company,
            //     isClear: respObject.panels[0].clear_dimension,
            //     loaded: true,
            //     data: respObject.panels[0]
            //   })
            // );
            this.checkIfMetaDone(sectionName);
          },
          (error) => {
            console.error(error);
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
        );
        // Source meta end
        // Period meta start
        this.dataService.getPeriodsMeta(params).subscribe(
          (respObject) => {
            if (respObject.status == "error") {
              this.dataService.displayMetaError(respObject); // maingrid3.js fn
              return;
            }
            this.periodData = respObject;

            window.filingsPerPeriodDict =
              this.periodData.panels[0].filing_date_data;
            // const periods = respObject.panels[0];
            // const payload: Periods = {
            //   clearDimension: periods.clear_dimension,
            //   firstEstimatedYear: periods.first_estimated_year,
            //   from: periods.from,
            //   to: periods.to,
            //   interimType: periods.interim_type,
            //   multiPeriod: periods.multi_period,
            //   periodType: periods.period_type,
            //   selectedFrom: periods.selected_from.slice(3, 7),
            //   selectedTo: periods.selected_to.slice(3, 7)
            // };

            // this.store.dispatch(new SetPeriods(payload));
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
          (error) => {
            console.error(error);
            this.metaCalls--;
            this.checkIfMetaDone(sectionName);
          },
        );
      }

      if (window.cut === "SAR") {
        this.getSarToNmvLinks();
      }
    } else {
      if (sectionName != "All") {
        var coldimensionData = $.map(
          window.MEData.column_dimensions,
          function (n, i) {
            if (n.name == sectionName) {
              return i;
            }
          },
        );
        var rowdimensionData = $.map(
          window.MEData.row_dimensions,
          function (n, i) {
            if (n.name == sectionName) {
              return i;
            }
          },
        );
        if (coldimensionData.length != 0) {
          window.MEData.column_dimensions.splice(coldimensionData[0], 1);
        } else if (rowdimensionData.length != 0) {
          window.MEData.row_dimensions.splice(rowdimensionData[0], 1);
        }
      }
      this.checkIfMetaDone(sectionName);
    }

    cleanUpInspector();
  }

  checkIfMetaDone(apiSectionName: any, sectionName?: any) {
    if (this.metaCalls <= 0) {
      this.allDataFetched(
        sectionName != undefined && sectionName != apiSectionName
          ? sectionName
          : apiSectionName,
      );
    }
  }

  allDataFetched(section: string) {
    //set all data since calls done
    //create MEData object by merging everything
    window.rightPanelChanges = {
      panels: [],
      column_dimensions: [],
      row_dimensions: [],
    };
    window.dsmObj = {
      dapValues: [],
      valuesSet: false,
    };
    if (section == "All") {
      window.MEData = this.allDimData;
      for (let val in this.lineItemData) {
        window.MEData[val] = this.lineItemData[val];
      }
    }
    if (section == "All" || section == "periods") {
      //periods
      let sectionPanel = window.MEData.panels.findIndex(function (value) {
        return value.name == section;
      });
      if (sectionPanel != -1) {
        window.MEData.panels[sectionPanel] = this.periodData.panels[0];
      } else {
        window.MEData.panels = window.MEData.panels.concat(
          this.periodData.panels,
        );
      }

      window.MEData.selectedCurrency = this.periodData.extras.currency
        ? this.periodData.extras.currency
        : "Base";
      this.onCurrencySet.emit(window.MEData.selectedCurrency);

      window.MEData.column_dimensions = window.MEData.column_dimensions.concat(
        this.periodData.column_dimensions,
      );
      if (!window.MEData.extras) {
        window.MEData.extras = { expandedColumns: [] };
      }

      const allColExpansions = window.MEData.extras.expandedColumns.concat(
        this.periodData.extras.expandedColumns,
      );
      window.MEData.extras.expandedColumns = allColExpansions;
      //window.MEData.extras.expandedColumns = allColExpansions.filter((val)=>val.colType !== 'period')
      let MEDataPanelObj = this.periodData.panels[0];
      MEDataPanelObj.values = [];
      for (
        let i = getYear(MEDataPanelObj.selected_from);
        i <= getYear(MEDataPanelObj.selected_to);
        i++
      ) {
        let periodPanel = MEDataPanelObj.all_period_expansion_list.filter(
          function (n) {
            return n.year == i;
          },
        );
        for (let item = 0; item < periodPanel.length; item++) {
          let value = periodPanel[item];
          let copyVal = value.forecast ? value.period + "E" : value.period;
          MEDataPanelObj.values.push(copyVal);
        }
      }
    }
    if (section == "All" || section == "Sources") {
      //sources
      if (this.sourceData.panels) {
        let sectionPanel = window.MEData.panels.findIndex(function (value) {
          return value.name == section;
        });
        if (sectionPanel != -1) {
          window.MEData.panels[sectionPanel] = this.sourceData.panels[0];
        } else {
          window.MEData.panels = window.MEData.panels.concat(
            this.sourceData.panels,
          );
        }
      }
      if (this.sourceData.column_dimensions) {
        window.MEData.column_dimensions =
          window.MEData.column_dimensions.concat(
            this.sourceData.column_dimensions,
          );
      }
    }
    if (section !== "All" && section != "periods" && section != "Sources") {
      let sectionPanel = window.MEData.panels.findIndex(function (value) {
        return value.name == section;
      });
      if (sectionPanel != -1) {
        window.MEData.panels[sectionPanel] = this.allDimData.panels.filter(
          function (value) {
            return value.name == section;
          },
        )[0];
      }
    }

    //create colDimension and rowDimension
    let periodPanels = window.MEData.panels.filter(function (n) {
      return n.name.toLowerCase() == "periods";
    })[0];
    let cdPeriodObj = {
      name: "periods",
      interim_type: periodPanels.interim_type,
      all_period_expansion_list: [],
      expansions: [],
      first_estimated_fiscal: periodPanels.first_estimated_fiscal,
      currentquarter: periodPanels.currentquarter,
      values: [],
      default_display_trend: periodPanels.default_display_trend,
      type: "column",
    };

    let startFY;
    let endFY;
    if (periodPanels.multi_period == true) {
      (startFY = periodPanels.selected_from),
        (endFY = periodPanels.selected_to);
    } else {
      (startFY = periodPanels.selected_from),
        (endFY = periodPanels.selected_from);
    }
    cdPeriodObj.values = [];

    for (let i = getYear(startFY); i <= getYear(endFY); i++) {
      let periodPanel = periodPanels.all_period_expansion_list.filter(
        function (n) {
          return n.year == i;
        },
      );
      for (let item = 0; item < periodPanel.length; item++) {
        let value = periodPanel[item];
        cdPeriodObj.values.push(value);
      }
    }

    window.MEData.column_dimensions = [cdPeriodObj];
    if (!window.MEData["extras"]) window.MEData["extras"] = {};
    window.MEData.tabs = this.tabs;

    //set globalVars for pg url
    this.setGlobalVariables();

    // $rootScope.MEData = MEData; - TODO check this
    // if(!this.mexLoaded) {
    //     console.log('interval needed')
    //     this.webServiceCallInterval = setInterval(function() {
    //         if(this.mexLoaded) {
    //             clearInterval(this.webServiceCallInterval);

    //             let objWebServiceCall = new WebServiceCall(); // maingrid3.js fn
    //             //main callGrid call. MEData set here
    //             objWebServiceCall.callGrid(true, null);
    //             // window.dispatchEvent(new CustomEvent('MEDataSet', { detail: {data: window.MEData, rightPanelChanges: window.rightPanelChanges} }));
    //             // $scope.$broadcast('MEDataSet', window.MEData, window.rightPanelChanges); // TODO
    //             this.onMEDataSet();
    //         }
    //     },50)
    // } else {
    setTimeout(() => {
      let objWebServiceCall = new WebServiceCall();
      //main callGrid call. MEData set here
      objWebServiceCall.callGrid(true, null, null, true);
      const MEDataSet = new CustomEvent("MEDataSet", {
        detail: {
          data: window.MEData,
          section: section,
          rightPanelChanges: window.rightPanelChanges,
        },
      });
      window.dispatchEvent(MEDataSet);
      // $scope.$broadcast('MEDataSet', window.MEData, window.rightPanelChanges); // TODO
      this.onMEDataSet();
    }, 500);
    // }
  }
  getAllPgData(onlyPgCall?) {
    const vaActualsCount = 3;
    const consensusCount = 5;
    const params = {
      pg: window.pg,
      cut: window.cut,
      ticker: window.company,
    };
    this.allPgDataFetched = false;
    this.allPgData = [];
    const apiCalls = [];
    for (let counter = 1; counter <= vaActualsCount; counter++) {
      apiCalls.push(this.dataService.getAllPg(params, counter, false));
    }
    for (let counter = 1; counter <= consensusCount; counter++) {
      apiCalls.push(this.dataService.getAllPg(params, counter, true));
    }

    forkJoin(apiCalls).subscribe((responses) => {
      this.firstTimePgCall = onlyPgCall ? false : true;
      responses.forEach((resp: any) => {
        this.allPgData.push(...resp.data);
      });
      this.allPgDataFetched = true;
      if (onlyPgCall) {
        let objWebServiceCall = new WebServiceCall();
        objWebServiceCall.loadDefaultDataFromPg({
          data: this.allPgData,
          status: "success",
        });
      }
    });
  }
  onMEDataSet() {
    this.showAsPctOfOption = window.MEData.baseparameter.name;
    var panelDataArr = [];
    for (var i = 0; i < window.MEData.dims_list.length; i++) {
      var temp = $.extend(
        true,
        {},
        window.panelSections[window.MEData.dims_list[i]],
      );
      temp.show = false;
      var panelIndex = $.map(this.panelData, function (value, index) {
        if (value.secName == temp.secName) {
          return index;
        }
      })[0];
      var panelObj = window.rightPanelChanges.panels.filter(function (value) {
        return value.name == temp.secName;
      })[0];
      if (panelObj) temp["panelData"] = panelObj;
      panelDataArr.push(temp);
      // temp.showClear = $scope.panelData[panelIndex] && $scope.showClearAll ? $scope.panelData[panelIndex].showClear : panelObj.clear_dimension;
      // setMEDataOnApply(temp.secName); // rightpanel.js fn
    }
    this.panelData = panelDataArr;
    if (this.cut !== "SAR" && this.cut !== "SCH" && this.firstTimePgCall) {
      const allPgInterval = setInterval(() => {
        if (this.allPgDataFetched) {
          clearInterval(allPgInterval);
          let objWebServiceCall = new WebServiceCall();
          objWebServiceCall.loadDefaultDataFromPg({
            data: this.allPgData,
            status: "success",
          });
          this.firstTimePgCall = false;
        }
      }, 10);
    } else {
      this.firstTimePgCall = false;
      this.allPgData = [];
    }
    this.getPharmaMetaData();

    // var panelData = window.rightPanelChanges.panels.filter(function(value) { return value.name == 'periods' })[0];
    // var periodList = panelData.all_period_expansion_list.map(function(v){
    //     return 'FY-'+v.year;
    // });

    // handling for clear source panel
    // var sourcesPanelData = window.rightPanelChanges.panels.filter(function(value) { return value.name === 'Sources' })[0];
    // if(sourcesPanelData){
    //     var brokersData = sourcesPanelData.values.filter(function (n) {
    //         return (n.name == "Brokers");
    //     })[0];
    //     $scope.brokerData = jQuery.extend(true, [], brokersData.values);
    //     $rootScope.brokerData = $scope.brokerData;
    // }

    // periodList = periodList.filter(function(item, pos){
    //   return periodList.indexOf(item)== pos;
    // });
    // $scope.periodDropdownlList = periodList.map(function(v){
    //     var forecast= getYear(v) >= getYear(panelData.first_estimated_year);
    //     var period = forecast ? v + 'E' : v;
    //     return {value:period, label: v};
    // });
    // $timeout(function(){
    //     if(window.MEData.panel_state.rightPanel && !$scope.isRightPanel){
    //         $('#panelarrow').trigger('click');
    //     }
    //     $scope.showConsensusPlus = (cut === "NMV" || cut === "SCH") && $rootScope.menuData.is_conplus_user;
    // },10);
  }
  bioPharmaFilterLinkGenerator(event) {
    if (this.hasPharmaAccess) {
      let key = event[0].value;
      const val = event[1].value;
      window.open(`/biopharma/database/filter?${key}=${val}`, "_blank");
    } else {
      window.open("https://visiblealpha.com/biopharma-request-demo/", "_blank");
    }
  }

  bioPharmaNavigation(tabId, drugId) {
    if (this.hasPharmaAccess) {
      if (tabId === "Sales Analysis") {
        tabId = 0;
      }
      if (tabId === "Analyst Estimates") {
        tabId = 1;
      }
      window.open(`/biopharma/drug/${drugId}?tab=${tabId}`);
    } else {
      window.open("https://visiblealpha.com/biopharma-request-demo/", "_blank");
    }
  }

  addCascader(selector, dpid, options) {
    if (!selector) {
      return;
    }
    if ($(selector).find("img.pharmaLineIcon").length) {
      return;
    }
    const trigger = `
                  <img width="20" height="10" class="pharmaLineIcon" style="opacity=1 !important;float:left !important"
                  dpid="${dpid}" src="${window.assetUrl}/pill.svg" alt="pharma navigation"/>
              `;

    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        NzCascaderComponent,
      );
    const selectorList = $(selector);
    if (!selector || !selectorList.length) {
      return;
    }
    for (let i = 0; i < selectorList.length; i++) {
      if ($(selectorList[i]).find("img.pharmaLineIcon").length) {
        continue;
      }
      const componentRef =
        this.biopharmaContextMenu.createComponent(componentFactory);
      componentRef.instance.nzOptions = options;
      componentRef.instance.nzTriggerAction = "click";
      componentRef.instance.nzExpandTrigger = "hover";
      componentRef.instance.nzShowInput = false;
      componentRef.instance.nzBackdrop = true;
      componentRef.instance.nzMenuClassName = "biopharma-cascader";
      componentRef.instance.nzMouseEnterDelay = 4000;
      componentRef.instance.nzColumnClassName = "biopharma-cascader";
      componentRef.instance.nzSelectionChange.subscribe((i) => {
        if (
          (i.length === 1 && i[0].label === "Sales Analysis") ||
          i[0].label === "Analyst Estimates"
        ) {
          this.bioPharmaNavigation(i[0].label, i[0].value);
          componentRef.instance.cascaderService.setOptionDeactivatedSinceColumn(
            2,
          );
        } else {
          this.bioPharmaFilterLinkGenerator(i);
        }
      });
      $(componentRef.instance["elementRef"]["nativeElement"]).append(trigger);
      this.renderer.appendChild(
        selectorList[i],
        componentRef.instance["elementRef"]["nativeElement"],
      );
      componentRef.changeDetectorRef.detectChanges();
    }
  }

  getPharmaMetaData() {
    if (
      !window.MEData.companyid ||
      !(this.industryId === 103 || this.industryId === 105)
    ) {
      return;
    }
    this.pharmaParms.companyids.push(window.MEData.companyid);
    this.pharmaParms.period_type = this.periodData.panels[0].period_type;
    if (
      window.biopharma_mex_grid_meta &&
      window.biopharma_mex_grid_meta[window.MEData.companyid]
    ) {
      this.hasPharmaAccess =
        window.biopharma_mex_grid_meta[
          window.MEData.companyid
        ].has_pharma_access;
      for (const dpid in window.biopharma_mex_grid_meta[
        window.MEData.companyid
      ]["data"]) {
        if (window.cut === "NMV" && $(`div[dpid='${dpid}']`).length > 0) {
          const options = [];
          options.push({
            label: "BioPharma",
            isLeaf: true,
            disabled: true,
          });
          if (
            window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
              dpid
            ].indications.length > 0
          ) {
            const children = window.biopharma_mex_grid_meta[
              window.MEData.companyid
            ]["data"][dpid].indications.map((child) => {
              return {
                value: child.mastertagid,
                label: `<span>
                    <span class="phase-pill" title="${child["phase"]}">${
                      this.phaseAbbr[child["phase"]]
                    }</span>
                    ${child["name"]}
                  </span>`,
                isLeaf: true,
                title: `${child["name"]}`,
              };
            });
            options.push({
              label: `Peers By Indication (${
                window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
                  dpid
                ].indications.length
              })`,
              value: "indication",
              children: children,
            });
          }
          if (
            window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
              dpid
            ].moa.length > 0
          ) {
            const children = window.biopharma_mex_grid_meta[
              window.MEData.companyid
            ]["data"][dpid].moa.map((child) => {
              return {
                label: child.name,
                value: child.mastertagid,
                isLeaf: true,
              };
            });
            options.push({
              label: `Peers By MOA (${
                window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
                  dpid
                ].moa.length
              })`,
              value: "moa",
              children: children,
            });
          }
          if (
            window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
              dpid
            ].target.length > 0
          ) {
            const children = window.biopharma_mex_grid_meta[
              window.MEData.companyid
            ]["data"][dpid].target.map((child) => {
              return {
                label: child.name,
                value: child.mastertagid,
                isLeaf: true,
              };
            });
            options.push({
              label: `Peers By Target (${
                window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
                  dpid
                ].target.length
              })`,
              value: "target",
              children: children,
            });
          }
          if (
            window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
              dpid
            ].api.length > 0
          ) {
            const children = window.biopharma_mex_grid_meta[
              window.MEData.companyid
            ]["data"][dpid].api.map((child) => {
              return {
                label: child.name,
                value: child.id,
                isLeaf: true,
              };
            });
            options.push({
              label: `Peers By API (${
                window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
                  dpid
                ].api.length
              })`,
              value: "api",
              children: children,
            });
          }
          if (
            window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
              dpid
            ].ctagid
          ) {
            options.push({
              label: "Sales Analysis",
              value:
                window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
                  dpid
                ].ctagid,
              isLeaf: true,
            });
            options.push({
              label: "Analyst Estimates",
              value:
                window.biopharma_mex_grid_meta[window.MEData.companyid]["data"][
                  dpid
                ].ctagid,
              isLeaf: true,
            });
          }
          this.addCascader(`div[dpid='${dpid}']`, dpid, options);
          // this.addCascader($("div[dpid]")[i],dpid);
        }
      }
    } else {
      if (this.pharmaMetaSubscription) {
        this.pharmaMetaSubscription.unsubscribe();
      }
      this.pharmaMetaSubscription = this.pharmaService
        .getPharmaMexGridMeta(this.pharmaParms)
        .subscribe((resp) => {
          this.hasPharmaAccess = resp.has_pharma_access;
          for (const dpid in resp.data) {
            if (window.cut === "NMV" && $(`div[dpid='${dpid}']`).length > 0) {
              const options = [];
              options.push({
                label: "BioPharma",
                isLeaf: true,
                class: "cascader-heading",
                disabled: true,
              });
              if (resp.data[dpid].indications.length > 0) {
                const children = resp.data[dpid].indications.map((child) => {
                  return {
                    label: `<span>
                            <span class="phase-pill" title="${
                              child["phase"]
                            }">${this.phaseAbbr[child["phase"]]}</span>
                            ${child["name"]}
                          </span>`,
                    value: child.mastertagid,
                    isLeaf: true,
                    title: `${child["name"]}`,
                  };
                });
                options.push({
                  label: `Peers By Indication (${resp.data[dpid].indications.length})`,
                  value: "indication",
                  children: children,
                });
              }
              if (resp.data[dpid].moa.length > 0) {
                const children = resp.data[dpid].moa.map((child) => {
                  return {
                    label: child.name,
                    value: child.mastertagid,
                    isLeaf: true,
                  };
                });
                options.push({
                  label: `Peers By MOA (${resp.data[dpid].moa.length})`,
                  value: "moa",
                  children: children,
                });
              }
              if (resp.data[dpid].target.length > 0) {
                const children = resp.data[dpid].target.map((child) => {
                  return {
                    label: child.name,
                    value: child.mastertagid,
                    isLeaf: true,
                  };
                });
                options.push({
                  label: `Peers By Target (${resp.data[dpid].target.length})`,
                  value: "target",
                  children: children,
                });
              }
              if (resp.data[dpid].api.length > 0) {
                const children = resp.data[dpid].api.map((child) => {
                  return {
                    label: child.name,
                    value: child.id,
                    isLeaf: true,
                  };
                });
                options.push({
                  label: `Peers By API (${resp.data[dpid].api.length})`,
                  value: "api",
                  children: children,
                });
              }
              if (resp.data[dpid].ctagid) {
                options.push({
                  label: "Sales Analysis",
                  value: resp.data[dpid].ctagid,
                  isLeaf: true,
                });
                options.push({
                  label: "Analyst Estimates",
                  value: resp.data[dpid].ctagid,
                  isLeaf: true,
                });
              }
              this.addCascader(`div[dpid='${dpid}']`, dpid, options);
            }
          }
          this.biopharma_mex_grid_meta[window.MEData.companyid] = {};
          this.biopharma_mex_grid_meta[window.MEData.companyid] = resp;
          window.biopharma_mex_grid_meta = this.biopharma_mex_grid_meta;
        });
    }
  }

  setGlobalVariables() {
    // reorder MEData.panels
    let panelOrder = [
      "periods",
      "Sources",
      "Revisions",
      "Accounting basis",
      "Adjustments",
      "GrowthTypes",
      "Analysis",
    ];
    window.MEData.panels = panelOrder
      .map(function (val) {
        let current = window.MEData.panels.filter(function (obj) {
          return obj.name === val;
        });
        return current[0];
      })
      .filter(function (val) {
        return val != undefined;
      });

    let valuepanels = window.MEData.panels.filter(function (value) {
      return value.name == window.panelSections["Analysis"].secName;
    })[0];
    let variationSliderValue = -1,
      revisionSliderValue = -1,
      selectedRevision = "-6Month",
      surpriseSliderValue = 5;
    if (valuepanels) {
      for (let index = 0; index < valuepanels.values.length; index++) {
        let value = valuepanels.values[index];
        if (value.name == "Show Variation") {
          variationSliderValue =
            value.slider > 0 ? value.slider * -1 : value.slider;
          window.cva = value.selected ? value.name : "";
        } else if (value.name == "Revisions") {
          revisionSliderValue =
            value.slider > 0 ? value.slider * -1 : value.slider;
          selectedRevision = value.value;
          window.crdrevision = value.selected ? value.value : "";
        } else if (value.name == "Surprise") {
          surpriseSliderValue = value.slider;
          window.surprise = value.selected ? value.name : "";
        } else if (value.name == "High / Low") {
          window.high_low_src = value.selected ? value.high_low_src : "";

          for (let ind = 0; ind < value.values.length; ind++) {
            let val = value.values[ind];
            if (val.name == "High") {
              window.high = value.selected && val.selected ? true : false;
            }
            if (val.name == "Low") {
              window.low = value.selected && val.selected ? true : false;
            }
          }
        }
      }
    }
    //default value
    window.gAdjust = "implied";
    window.samplecolrow = JSON.parse(JSON.stringify(window.MEData));
    window.MEData.view_code = window.cut;
    //default revisions
    let revPanel = window.MEData.panels.filter(function (value) {
      return value.name == "Revisions";
    })[0];
    let object = this.revisionDimension();
    let coldimensionData = $.map(
      window.MEData.column_dimensions,
      function (n, i) {
        if (n.name == "Revisions") {
          return i;
        }
      },
    );
    let rowdimensionData = $.map(window.MEData.row_dimensions, function (n, i) {
      if (n.name == "Revisions") {
        return i;
      }
    });

    if (revPanel.type == "row") {
      if (rowdimensionData.length == 0)
        window.MEData.row_dimensions.push(object);
      else window.MEData.row_dimensions[rowdimensionData[0]] = object;
    } else if (revPanel.type == "column") {
      if (coldimensionData.length == 0)
        window.MEData.column_dimensions.push(object);
      else window.MEData.column_dimensions[coldimensionData[0]] = object;
    } else {
      // if type is off
      delete window.MEData.row_dimensions[rowdimensionData[0]];
      delete window.MEData.column_dimensions[coldimensionData[0]];
    }

    let defaultData = window.MEData.panels.filter(function (n) {
      return n.name == "Tickers";
    });
    if (defaultData.length > 0) {
      let object = JSON.parse(JSON.stringify(defaultData[0]));
      window.MEData.column_dimensions.push(object);
    }
    //haedcoded as same for all calls
    window.MEData.inspector = {
      default: "Lineitem",
      values: [
        {
          name: "Line Item Details",
          type: "Lineitem",
        },
        {
          name: "Sources",
          type: "Sources",
        },
        {
          type: "Peers",
          name: "Peers",
        },
        {
          type: "Comptable",
          name: "Comp Table Mapping",
        },
      ],
    };

    /**
     * commenting below snippet and adding peers as an always available tab
     * because visibility of peers tab can be conveniently handled instead
     * of actually removing the tab on SAR page
     * This causes inconsistency when user navigates from SAR to any other cut
     * because the moment of MEData.inspector's update is unknown.
     * reference bug: CACHE-1932
     */
    // if (window.MEData.global_sli == true) {
    //   (window.MEData.inspector.default = "Sources"),
    //     window.MEData.inspector.values.push({ type: "Peers", name: "Peers" });
    // }

    window.MEData.panel_state = this.allDimData.panel_state;
    window.gSourceFuture = "";
    window.gSourceActual = "";

    //create dimensions for analytics
    this.setAnalyticsInRowDimensions();
  }

  revisionDimension() {
    if (typeof window.samplecolrow == "undefined") return {};
    let defaultData = window.samplecolrow.panels.filter(function (n) {
      return n.name == "Revisions";
    });
    let object = {
      expansions: [],
      values: [
        {
          expanded: false,
          name: defaultData[0]["default"],
        },
      ],
      name: "Revisions",
    };
    let sortedValues = this.sortRevision(defaultData[0].values.slice());
    sortedValues.forEach(function (value) {
      if (value) {
        object.expansions.push(value);
      }
    });
    return object;
  }

  sortRevision(values) {
    let sortedValues = [];
    let dates = [];
    values.forEach(function (value) {
      if (value && value != "PreQ") {
        let days = value.match(/\d+(?=D)/g),
          months = value.match(/\d+(?=M)/g),
          weeks = value.match(/\d+(?=W)/g),
          revisionDate = new Date(),
          currentDate = new Date();
        weeks = Number(weeks);
        days = Number(days);
        months = Number(months);
        if (!isNaN(months)) {
          revisionDate.setMonth(currentDate.getMonth() - months);
        }
        if (!isNaN(weeks) && weeks > 0) {
          days = days + weeks * 7;
        }
        if (!isNaN(days)) {
          revisionDate.setDate(currentDate.getDate() - days);
        }
        dates.push({
          relativeDate: value,
          date: revisionDate,
        });
      }
    });

    dates.sort(function (a, b) {
      return new Date(a.date).getTime() - new Date(b.date).getTime();
    });
    dates.forEach(function (value) {
      sortedValues.push(value.relativeDate);
    });
    if (values.indexOf("PreQ") != -1) {
      sortedValues.push("PreQ");
    }
    return sortedValues;
  }

  setAnalyticsInRowDimensions() {
    const analyticsData = window.MEData.panels.find(
      (panel) => panel.name.toLowerCase() === "growthtypes",
    );

    const analyticsDimensions: any = {
      expansions: this.orderAnalytics(analyticsData.values),
      values: [
        {
          expanded: false,
          name: "Analytics",
        },
      ],
      name: "GrowthTypes",
    };

    if (analyticsData.values.includes("Trend")) {
      analyticsDimensions.trendYear = analyticsData.trendYear;
    }

    window.MEData.row_dimensions = window.MEData.row_dimensions.filter(
      (dimen) => dimen !== undefined,
    );
    const growthTypeIdx = window.MEData.row_dimensions.findIndex(
      (dimension) => dimension.name === "GrowthTypes",
    );

    if (analyticsData.values.length > 0) {
      if (growthTypeIdx > -1) {
        window.MEData.row_dimensions[growthTypeIdx] = analyticsDimensions;
      } else {
        window.MEData.row_dimensions.push(analyticsDimensions);
      }
    } else {
      if (growthTypeIdx > -1) {
        window.MEData.row_dimensions.splice(growthTypeIdx, 1);
      }
    }
  }

  orderAnalytics(analyticsValues) {
    const transform = (analyticType) => {
      const weight = {
        "YoY%": 6,
        "YoY#": 5,
        "Seq%": 4,
        "Seq#": 3,
        Trend: 2,
        "%": 1,
      };
      return weight[analyticType];
    };
    const sorted = this.appService.basicSort(
      analyticsValues,
      [],
      true,
      transform,
    );
    return sorted;
  }

  loadAllTitles() {
    qtipSettings($("#Exporttoexcel"), "qttitle", true); // qtipHandler.js fn
    qtipSettings($("#Saveview"), "qttitle", true);
    qtipSettings($("#Copyshareableurl"), "qttitle", true);
    qtipSettings($("#Img5.panel").closest("tr"), "qttitle", true);
    let ele = $("#mm").find('div[paneltype="legend"]');
    ele.attr("qttitle", "<b>Legend</b>");
    qtipSettings(ele, "qttitle", true);
    qtipSettings($("#Img7.panel").closest("tr"), "qttitle", true);
    qtipSettings($("#panelarrow"), "qttitle", true);
    $("#inferredLegend")
      .find("div")
      .each(function (i, el) {
        qtipSettings($(this), "qttitle", true);
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      //remove stranded qtips
      if ($(".qtip-active").length > 0) {
        $(".qtip-active").remove();
      }
      $(".colrow").click(function (a) {
        $("#" + a.currentTarget.id)
          .closest("table")
          .removeClass()
          .addClass(
            $("#" + a.currentTarget.id).attr("value") + "selected tablecolrow",
          );
      });

      //------------------- start panel toggle
      this.loadAllTitles();
    }, 300);
  }

  onCurrencyChange = function (currency) {
    this.selectedCurrency = currency;
    debouncedBlock(true);
    window.MEData.selectedCurrency = this.selectedCurrency;
    saveExtraPanelSetting().then(() => {
      this.loadGridCalled(true, "All");
    });
  };

  redirectToMonitor() {
    this.router.navigate([`/company/${window.company}`]);
  }

  hideChartPopup() {
    this.chartReady = false;
    this.chartType = "";
  }

  addToMonitorUpdate(jsonData) {
    const params: UpdateLineItemParams = {
      ticker: jsonData.ticker,
      line_ids: jsonData.lineIds,
      append_lines: jsonData.fromMexPage,
    };
    this.limDataService.updateLimLines(params).subscribe(
      (response) => {
        let colorClass = "success";
        this.responseMessage = (response as any).message;
        if (this.responseMessage === "Monitor limit exceeded.") {
          this.messageSuffix = "to adjust.";
          colorClass = "warning";
        } else {
          this.messageSuffix = ".";
        }

        this.snackBar.openFromTemplate(this.snackbarTemplateAddToMonitor, {
          panelClass: colorClass,
          duration: 5000,
          verticalPosition: "top",
        });
      },
      () => {
        this.snackBar.open("Something went wrong.", "", {
          panelClass: "warning",
          duration: 3000,
          verticalPosition: "top",
        });
      },
    );
  }

  showResearchInsightPopup(dataObj) {
    this.currentDapObj = dataObj;
    this.showResearchPopup = true;
  }
  hideResearchInsightPopup() {
    this.showResearchPopup = false;
  }
  callDefaultSetting() {
    window.callDefaultSetting("All");
  }
}
